import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getSocket } from '@/lib/socket';

const REALTIME_RESYNC = 'realtime:resync';

/**
 * Listens for `realtime:resync` from the gateway and invalidates the React
 * Query cache so anything that may have drifted while the socket was
 * disconnected gets refetched on its next render.
 *
 * The gateway emits this immediately after every (re)connect — including the
 * very first one — so this also serves as a free "warm me up" trigger when
 * the FE boots with stale localStorage cache.
 *
 * Mount this once near the root, inside QueryClientProvider. Per-feature
 * tuning (only invalidating specific query keys) can come later if broad
 * invalidation turns out to be too aggressive; for now the simplicity wins.
 */
export function useRealtimeResync(): void {
  const queryClient = useQueryClient();
  useEffect(() => {
    const socket = getSocket();
    const onResync = (payload: { ts?: string } = {}) => {
      console.info('[realtime] resync', payload.ts);
      void queryClient.invalidateQueries();
    };
    socket.on(REALTIME_RESYNC, onResync);
    return () => {
      socket.off(REALTIME_RESYNC, onResync);
    };
  }, [queryClient]);
}
